import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";
import MoneyFlow from "../components/MoneyFlow";

/**
 * Scene 42 — The climax. £2.4 million a year.
 */

export default function Scene42_TwoPointFourMillion() {
  return (
    <SceneShell variant="gold" align="center" data-testid="scene-2-4m">
      <MoneyFlow density={56} color="rgba(255,232,168,0.90)" symbol="£" />
      <MoneyFlow density={28} color="rgba(255,255,255,0.55)" symbol="£" />

      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at center, rgba(255,232,168,0.30) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(255,232,168,0.50) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(255,232,168,0.30) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Concentric rings */}
      {[0, 1, 2].map((i) => (
        <motion.span
          key={i}
          className="absolute top-1/2 left-1/2 rounded-full border pointer-events-none"
          style={{
            width: 200,
            height: 200,
            borderColor: "rgba(255,232,168,0.55)",
            translate: "-50% -50%",
          }}
          animate={{ scale: [1, 5], opacity: [0.55, 0] }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeOut",
            delay: 1.4 + i * 1.2,
          }}
        />
      ))}

      <div className="relative max-w-[1600px] mx-auto w-full text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.6, filter: "blur(32px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.7, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10"
          data-testid="2-4m-number"
        >
          <div
            className="kn-display tnum leading-[0.85]"
            style={{
              fontSize: "clamp(140px, 22vw, 360px)",
              color: "#0d0d0f",
              textShadow:
                "0 8px 60px rgba(0,0,0,0.30), 0 0 120px rgba(255,255,255,0.55)",
              whiteSpace: "nowrap",
              fontWeight: 900,
            }}
          >
            £2.4M
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.0, delay: 2.6 }}
          className="mt-2 kn-display text-3xl sm:text-5xl lg:text-6xl"
          style={{ color: "#0d0d0f", fontWeight: 800 }}
        >
          a year.
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.0, delay: 3.2 }}
          className="mt-12 inline-flex items-center gap-5 rounded-full px-7 py-3"
          style={{
            background: "rgba(0,0,0,0.78)",
            color: "rgba(255,255,255,0.92)",
          }}
        >
          <span className="text-xs tracking-[0.32em] uppercase text-white/60">
            From content
          </span>
          <span className="text-base sm:text-lg" style={{ color: "#e9a820", fontWeight: 700 }}>
            we're already capturing.
          </span>
        </motion.div>
      </div>
    </SceneShell>
  );
}
